import { render, staticRenderFns } from "./update-browser.vue?vue&type=template&id=3b8caec0"
import script from "./update-browser.vue?vue&type=script&lang=js"
export * from "./update-browser.vue?vue&type=script&lang=js"
import style0 from "./update-browser.vue?vue&type=style&index=0&id=3b8caec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports